import { ShieldOff, Mail, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export function SuspendedScreen() {
  const { signOut, profile } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <ShieldOff className="w-8 h-8 text-red-600" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Account gesperrt
        </h1>

        <p className="text-gray-600 mb-6">
          Dein Account wurde vorübergehend gesperrt. Dies kann verschiedene Gründe haben,
          wie z.B. einen Verstoß gegen unsere Nutzungsbedingungen.
        </p>

        <div className="bg-gray-50 rounded-xl p-4 mb-6">
          <p className="text-sm text-gray-500 mb-1">Eingeloggt als</p>
          <p className="font-medium text-gray-900">{profile?.email}</p>
        </div>

        <div className="space-y-3">
          <a
            href="mailto:support@mamal.app"
            className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-primary text-white rounded-xl hover:bg-primary-dark transition-colors font-medium"
          >
            <Mail className="w-5 h-5" />
            Support kontaktieren
          </a>

          <button
            onClick={handleSignOut}
            className="flex items-center justify-center gap-2 w-full px-4 py-3 border border-gray-200 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors font-medium"
          >
            <LogOut className="w-5 h-5" />
            Abmelden
          </button>
        </div>

        <p className="text-xs text-gray-400 mt-6">
          Wenn du glaubst, dass dies ein Fehler ist, kontaktiere bitte unseren Support.
        </p>
      </div>
    </div>
  );
}
